<template>
    <div class="container" v-bind:class="{ 'rtl': rtl}">

        <section class="top-cat">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 v-if="lang === 'ar'">لوحة حسابك</h1>
                        <h1 v-else>ACCOUNT DASHBOARD</h1>
                        <p v-if="lang === 'ar'"><span>نقدم لك أفضل الخصومات على الإطلاق</span></p>
                        <p v-else>SERVING YOU THE BEST DISCOUNTS EVER</p>
                    </div>
                </div>
            </div>
        </section>


        <div class="row">
            <div class="col-md-4">
                <img src="/static/images/nationalities/saudi.png"  style="max-width: 350px;">
<!--                class="rounded-circle"-->
            </div>
            <div class="col-md-8">
                <div class="container-fluid" style="background-color: white; padding: 35px; border: solid 1px gray;">
                    <div class="row">
                        <div class="col-md-8">
                            <h1 v-if="lang === 'ar'">مرحبا بك, {{user.firstName}} {{user.lastName}}</h1>
                            <h1 style="font-size: 32px;" v-else>Welcome, {{user.firstName}} {{user.lastName}}</h1>

                        </div>
                        <div class="col-md-4">
                          <a v-if="lang === 'ar'" target="_blank" :href="'http://system.alnokhbamarkets.com/card/'+user.card"> <button type="button" class="buttony" style="padding: 10px;"><icon name="credit-card" scale="1.5"></icon> &nbsp; تحميل البطاقة</button></a>
                          <a v-if="lang === 'en'" target="_blank" :href="'http://system.alnokhbamarkets.com/card/'+user.card"> <button type="button" class="buttony" style="padding: 10px;"><icon name="credit-card" scale="1.5"></icon> &nbsp; Download Card</button></a>

                          <!--                            <router-link v-if="lang === 'en'" to="/profile">-->
<!--&lt;!&ndash;                                <span class="float-right" style="width: 100px; height: 25px; padding: 5px 5px 20px 5px; font-size: 12px; font-weight: bold; background-color: #e74c3c; color: white; padding-bottom: 15px;">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <icon name="user" scale="1"></icon> Update Profile&ndash;&gt;-->
<!--&lt;!&ndash;                                </span>&ndash;&gt;-->
<!--                            </router-link>-->
                        </div>
                      <div class="col-md-12"><hr/></div>
                        <div v-if="lang === 'ar'" class="col-md-2 font-weight-bold">رقم هاتفك</div>
                        <div v-else class="col-md-2 font-weight-bold">Mobile</div>
                        <div class="col-md-4">{{user.mobile}}</div>

                        <div v-if="lang === 'ar'" class="col-md-3 font-weight-bold">الحالة الزوجية</div>
                        <div v-else class="col-md-3 font-weight-bold">Marital Status</div>
                        <div class="col-md-3">{{findMarital(user.maritalStatus)}}</div>

                        <div v-if="lang === 'ar'" class="col-md-2 font-weight-bold">البريد الإلكتروني</div>
                        <div v-else class="col-md-2 font-weight-bold">Email</div>
                        <div class="col-md-4">{{user.email}}</div>

                        <div v-if="lang === 'ar'" class="col-md-3 font-weight-bold">جنسية</div>
                        <div v-else class="col-md-3 font-weight-bold">Nationality</div>
                        <div class="col-md-3">{{user.nationality.name}}</div>

                        <div v-if="lang === 'ar'" class="col-md-2 font-weight-bold">مدينة</div>
                        <div v-else class="col-md-2 font-weight-bold">City</div>
                        <div class="col-md-4">{{findCity(address.cities_id)}}</div>

                        <div v-if="lang === 'ar'" class="col-md-3 font-weight-bold">جنس</div>
                        <div v-else class="col-md-3 font-weight-bold">Gender</div>
                        <div class="col-md-3">{{findGender(user.gender)}}</div>

                        <div class="col-md-12">
                            &nbsp;
                            <!--                            <p v-if="lang === 'ar'"><span>يتم عرض نقاط المكافأة الخاصة بك أدناه:</span></p>-->
<!--                            <p v-else>Please find your reward points calculations below:</p>-->
                        </div>
                        <div class="col-md-6">
                            <span v-if="lang === 'ar'" style="color: #1e88e5; font-family: 'Cooper Black'; font-size: 30px; padding-top: 10px;" >المجموع الحالي <br/></span>
                            <span v-else style="color: #1e88e5; font-family: 'Cooper Black'; font-size: 30px; padding-top: 10px;" >Reward Points <br/></span>
                            <span style="color: #1e88e5; font-family: 'Cooper Black'; font-size: 80px;">{{user.rewardPoints}}</span>
                        </div>
                        <div class="col-md-6">
                            <span v-if="lang === 'ar'" style="color: #7bc002; font-family: 'Cooper Black'; font-size: 30px; padding-top: 10px;" >الأموال المتاحة للإنفاق <br/></span>
                            <span v-else style="color: #7bc002; font-family: 'Cooper Black'; font-size: 30px; padding-top: 10px;" >Amount to Spend <br/></span>
                            <span style="color: #7bc002; font-family: 'Cooper Black'; font-size: 80px;">
                              <span v-if="countryMain === 1" style="font-size: 30px;">{{user.rewardAmount}} SR</span>
                              <span v-if="countryMain === 19" style="font-size: 30px;">{{user.rewardAmount/10}} BD</span>
                            </span>
                        </div>
                        <div class="col-md-12">
                            <p v-if="lang === 'ar'"><span> ملاحظة ، يتم تحديث نقاط المكافأة على خلال 24 ساعة. يرجى الانتظار للحصول على أحدث النقاط.</span></p>
                            <p v-else>Please note the points above are updated every 24 hours. Please wait for the latest points.</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <section class="top-cat">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 v-if="lang === 'ar'"><icon name="shopping-cart" scale="5"></icon>آخر المشتريات</h1>
                        <h1 v-else><icon name="shopping-cart" scale="5"></icon>LATEST PURCHASES</h1>
                        <p v-if="lang === 'ar'"><span>إجمع النقاط على كل عملية شراء</span></p>
                        <p v-else>Collect Points on Every Purchase</p>
                    </div>
                </div>
            </div>
        </section>


<!--        <div class="container" style="background-color: white; padding: 25px; border: solid 1px gray;">-->
<!--            <div class="row">-->
<!--                <div class="col-md-12">-->
<!--                    <table class="table table-hover" style="margin-top: 10px;" v-if="transactions">-->
<!--                        <thead>-->
<!--                        <th v-if="lang === 'ar'" scope="col">تاريخ</th>-->
<!--                        <th v-else scope="col">Date</th>-->
<!--                        <th v-if="lang === 'ar'" scope="col">اسم مركز التسوق</th>-->
<!--                        <th v-else scope="col">Store Name</th>-->
<!--                        <th v-if="lang === 'ar'" scope="col">رقم الفاتورة</th>-->
<!--                        <th v-else scope="col">Transaction ID</th>-->
<!--                        <th v-if="lang === 'ar'" scope="col">مبلغ الشراء</th>-->
<!--                        <th v-else scope="col">Purchase Amount</th>-->
<!--                        <th v-if="lang === 'ar'" scope="col">النقاط المسجلة</th>-->
<!--                        <th v-else scope="col">Points Scored</th>-->
<!--                        </thead>-->

<!--                        <tbody>-->
<!--                        <tr v-for="transaction in transactions">-->
<!--                            <th>{{$moment(transaction.transDate).format('ddd DD-MM-YYYY')}}</th>-->
<!--                            <td>{{transaction.storeName}}</td>-->
<!--                            <td>{{transaction.id}}</td>-->
<!--                            <td>{{transaction.tranAmount}}</td>-->
<!--                            <td>{{transaction.rewardPoints}}</td>-->
<!--                        </tr>-->
<!--                        </tbody>-->
<!--                    </table>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->



        <section class="top-cat">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 v-if="lang === 'ar'"><icon name="tags" scale="5"></icon> آخر النقاط المستخدمة</h1>
                        <h1 v-else><icon name="tags" scale="5"></icon> LATEST POINTS REDEEMED</h1>
                        <p v-if="lang === 'ar'"><span>استمتع بفوائد التسوق</span></p>
                        <p v-else>ENJOY THE BENEFITS OF ROYALTY WITH US</p>
                    </div>
                </div>
            </div>
        </section>


        <div class="container" style="background-color: white; padding: 25px; border: solid 1px gray; margin-bottom: 100px;">
            <div class="row">
                <div class="col-md-12">
                    <table class="table table-hover" style="margin-top: 10px;" v-if="redeemed">
                        <thead>
                        <th v-if="lang === 'ar'" scope="col">تاريخ</th>
                        <th v-else scope="col">Date</th>
                        <th v-if="lang === 'ar'" scope="col">اسم مركز التسوق</th>
                        <th v-else scope="col">Store Name</th>
                        <th v-if="lang === 'ar'" scope="col">رقم الفاتورة</th>
                        <th v-else scope="col">Transaction ID</th>
                        <th v-if="lang === 'ar'" scope="col">النقاط المستخدمة</th>
                        <th v-else scope="col">Points Used</th>
                        </thead>

                        <tbody>
                        <tr v-for="redeem in redeemed">
                            <td>{{$moment(redeem.transDate).format('ddd DD-MM-YYYY')}}</td>
                            <td>{{redeem.storeName}}</td>
                            <td>{{redeem.id}}</td>
                            <td>{{redeem.rewardPoints}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import {Form, Errors} from '@/components/validations/forms';
    import router from './../../router'

    import {mixin} from '@/mixins/mixins';
    export default {
        mixins: [mixin],
        data () {
            return {
                cardNumber: 1,
                form: new Form({
                    firstName: null,
                    lastName: null,
                    email: null,
                    password: null,
                    card: null,
                    mobile: null,
                    code: null,
                    birthday: null,
                    gender: null,
                    nationality: null,
                    iqama: null,
                    marital: null,
                    language: null,
                    street: null,
                    city: null,
                    postcode: null,
                    country: null,
                }),

                cities: this.$store.getters['environment/getCities'],
                countries: this.$store.getters['environment/getCountries'],
                nationalities: this.$store.getters['environment/getNationalities'],
                genders: this.$store.getters['environment/getGender'],
                maritalStatuses: this.$store.getters['environment/getMaritalStatus'],
                languages: this.$store.getters['environment/getLanguages'],

                user: this.$store.getters['user/getUser'],
                address: this.$store.getters['user/getAddress'],
                transactions: this.$store.getters['user/getTransactions'],
                redeemed: this.$store.getters['user/getRedeemed'],
            }
        },

        computed: {
            countryMain1 () {
                return this.$store.getters['environment/getCountryMain']
            },
        },

        methods: {
            onSelectGender(value){this.form.gender = value.id;},
            onSelectBirthday(value){this.form.birthday = this.$moment(value).format('YYYY-MM-DD');},
            onSelectNationality(value){this.form.nationality = value.id;},
            onSelectMarital(value){this.form.marital = value.id;},
            onSelectLanguage(value){this.form.language = value.id;},
            onSelectCity(value){this.form.city = value.id;},
            onSelectCountry(value){this.form.country = value.id;},
            findCity(id){for (let s of this.cities) {if(s.id == id){return s.name}}},
            findGender(id){for (let s of this.genders) {if(s.id == id){return s.name}}},
            findMarital(id){for (let s of this.maritalStatuses) {if(s.id == id){return s.name}}},

            loadData(){
                this.$store.dispatch('environment/fetchCities')
                    .then(response => {this.cities = this.$store.getters['environment/getCities'];})

                this.$store.dispatch('environment/fetchCountries')
                    .then(response => {this.countries = this.$store.getters['environment/getCountries'];})

                this.$store.dispatch('environment/fetchNationalities')
                    .then(response => {this.nationalities = this.$store.getters['environment/getNationalities'];})

                this.$store.dispatch('user/fetchUser')
                    .then(response => {this.user = this.$store.getters['user/getUser'];})

                this.$store.dispatch('user/fetchAddress')
                    .then(response => {this.address = this.$store.getters['user/getAddress'];})

                this.$store.dispatch('user/fetchTransactions')
                    .then(response => {this.transactions = this.$store.getters['user/getTransactions'];})

                this.$store.dispatch('user/fetchRedeemed')
                    .then(response => {this.redeemed = this.$store.getters['user/getRedeemed'];})
            },

        },

        mounted() {
            this.loadData();
        },
    }
</script>
<style>
    .buttony{
        color: white !important;
        background: #e74c3c !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/account/dashboard.vue